
import { useParams } from 'react-router-dom';
import { BarriosFormState } from '../../../context/barrios/BarriosFormState';
import { Form } from './form';

export const BarriosFormPage = () => {
  const { id } = useParams();
  const title = id ? "Editar Barrio":"Crear Barrio"

  return (
    <BarriosFormState>
        <br />
        <Form title={title} />
    </BarriosFormState>
  );
};